const countryStateColors = {
  updated: '#337ab7',
  updatedOffline: '#1da9bf',
  old: '#3cb9ff',
  oldOffline: '#01bedc',
  noReport: '#dcdcdc'
};

const mapStyle = {
  positioning: {
    position: 'relative',
    width: '100%',
    height: '300px' /* hardcoded number, dynamic would be more elegant, but it's not that disturbing */
  },
  coloring: {
    borderColor: '#eee',
    fillColor: '#fff',
    nonMemberstateFill: '#fff'
  },
  highlighting: {
    highlightFillColor: '#3cc3ffa8',
    highlightBorderColor: '#eee'
  }
};

export default mapStyle;
export {
  countryStateColors
};



// WEBPACK FOOTER //
// ./src/components/Home/DataMap/mapStyle.js